import { Component, OnInit, Injector, ElementRef, ViewChild } from '@angular/core';
import { tradeskHistoryTabComponent } from '../tradedeskTabs/orders/tradeskHistoryTab/tradeskHistoryTab.component';
import { DataService } from '../../services/data/data.service';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'mobile-trade-desk-history-tab',
  template: require('./mobile-trade-desk-history-tab.component.html'),
  styles: [require('./mobile-trade-desk-history-tab.component.css')]
})
export class MobileTradeDeskHistoryTabComponent extends tradeskHistoryTabComponent
{
  getRowHeight = () => 40;
  @ViewChild("balanceContainer") public balanceContainer!: ElementRef;
  constructor(injector: Injector, protected elRef: ElementRef, public dataService: DataService, public parserFormatter: NgbDateParserFormatter) 
  {
    super(injector, elRef, dataService,parserFormatter);
    this.gridOptions.headerHeight = 40;
    this.gridOptions.rowBuffer = 1000000;
   // this.gridOptions.onSortChanged = this.redraw;
    this.setColumnDefs();
  }

  public get balanceContainerHeight():any
  {
    return this.balanceContainer.nativeElement.offsetHeight || 0;
  }


    public get calculateHeight()
    {
      return {
        height:'calc( 100% - '+ (this.balanceContainerHeight )+'px )'
      }
      
    }


    public redraw(e:any)
    {
      if(this.gridOptions && this.gridOptions.api)
      this.gridOptions.api.redrawRows()
    }



  setColumnDefs()
  {
    for(let i = 0; i < this.columnDefs.length; i++)
    {
      const colDef = this.columnDefs[i];

      if(colDef.headerName == 'Entry Time')
      {
        colDef.width = colDef.minWidth = 200;
      }

      if(colDef.headerName == 'Close Time')
      {
        colDef.width = colDef.minWidth = 200;
      }

      if(colDef.headerName == 'Entry Price')
      {
        colDef.width = colDef.minWidth = 130;
      }

      if(colDef.headerName == 'Close Price')
      {
        colDef.width = colDef.minWidth = 130;
      }

      if(colDef.headerName == 'Profit/Loss')
      {
        colDef.width = colDef.minWidth = 130;
      }

      if(colDef.headerName == 'Ticket')
      {
        colDef.minWidth = colDef.width = 100;
      }

      this.setCellStyle(colDef);
    }
  }

  setCellStyle(columnDef: any)
  {
    columnDef.cellStyle = Object.assign(columnDef.cellStyle || {}, 
    {
      'font-size': '16px !important', 
      'line-height': this.getRowHeight() + 'px !important',
      'text-align': 'left'
    });
  }


}
